import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App.jsx';
import { bootstrapAuth } from './lib/sso.js';

// Bootstrap de auth ANTES de renderizar:
// - Captura ?sso_token= (vindo do Gesthub) e salva
// - Se não tem JWT → redireciona pro Gesthub SSO
// Em dev local (host = 127.0.0.1 ou localhost), pula SSO (X-User suficiente)
const isDev = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname);
const ok = isDev ? true : bootstrapAuth();

if (ok) {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
